import classNames from 'classnames';
import { Plus } from 'lucide-react';
import { theme } from 'styles/theme/theme';
import UDButton from 'ud-ui/components/button';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { DivProps } from '../../../../../../typings';

interface IProps extends DivProps {
  title: string;
  createButtonText?: string;
  createButtonOnClick?: () => void;
}

function HeaderContentCategory(props: IProps) {
  const { title, createButtonText, createButtonOnClick, className, ...rest } = props;

  return (
    <div className={classNames('flex items-center', className)} {...rest}>
      <UDHeaderTitle>{title}</UDHeaderTitle>
      <div className="flex justify-end">
        {createButtonText && createButtonOnClick && (
          <UDButton className="ml-6 flex items-center" variant="primary" onClick={createButtonOnClick}>
            <Plus size={16} className="mr-2" color={theme.colors.DarkBlue} />
            <span>{createButtonText}</span>
          </UDButton>
        )}
      </div>
    </div>
  );
}

export default HeaderContentCategory;
